import { Route, Switch } from "wouter";
import { ChatLayout2 } from "@/chat2/components/chatlayout/ChatLayout2";
import { KeycloakProvider } from "@/contexts/keycloak";
import { CoreProviders } from "@/providers/CoreProviders";
import { InviteLanding } from "@/pages/InviteLanding";
import { EventDebugProvider } from "@/contexts/eventDebugContext";
import { EventInspector } from "@/components/dev/EventInspector";
import { getConfigSync } from "@/lib/config";

/**
 * Main App component.
 *
 * Provider hierarchy:
 * - KeycloakProvider: Authentication (must be at top)
 * - CoreProviders: Session, Socket, Permissions, Notifications
 * - Routes: Different pages of the app
 *
 * Routes:
 * - /invite/:key - Invite redemption page
 * - /t/:type/:id? - Main chat layout with specific tab focused
 * - / - Main chat layout (no specific tab)
 */
export const App = () => {
  const stagingBanner = getConfigSync().stagingBanner;

  return (
    <EventDebugProvider initialConfig={{ enabled: true, maxEntries: 500, captureArgs: true }}>
      <KeycloakProvider loginRequired>
        <CoreProviders>
          <div className="fixed inset-0 flex flex-col h-[100dvh]">
            {stagingBanner && (
              <div className="shrink-0 bg-amber-500 text-black text-center text-xs font-semibold py-1 select-none z-[9999]">
                {stagingBanner}
              </div>
            )}
            <div className="flex-1 min-h-0">
              <Switch>
                <Route path="/invite/:key">
                  {(params) => <InviteLanding inviteKey={params.key} />}
                </Route>
                {/* Catch-all for main app - TabsContext handles URL parsing */}
                <Route>
                  <ChatLayout2 className="h-full" />
                </Route>
              </Switch>
            </div>
          </div>
        </CoreProviders>
      </KeycloakProvider>
      {process.env.NODE_ENV === 'development' && <EventInspector />}
    </EventDebugProvider>
  );
};
